import React from 'react'
import PropTypes from 'prop-types'
import { lightFormat } from 'date-fns'
import { date } from 'constants/dateFormats'
import { Text } from 'shared/components'

export const DateCell = ({ value }) => {
  return !value ? (
    <Text size={11}>–</Text>
  ) : (
    <Text size={11}>{lightFormat(new Date(value), date)}</Text>
  )
}

DateCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}
